import React from 'react';

export default class Preloader extends React.Component {

    render() {
        return (
            <div className="preloader" style={{display: 'block'}}>
                <div className="loading">
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                </div>
            </div>
        );
    }
}
